import Axios from 'axios'
import qs from 'qs'
import router from './router'
import { store, logOut } from './store'
import { logout, updateSessionTimeout } from './vuex-actions'

const instance = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  headers: { Accept: 'application/json' },
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
})

instance.interceptors.response.use(
  (response) => {
    localStorage.removeItem('pdfjs.history')

    if (response && response.status >= 200 && response.status < 300 && store.getters.isLoggedIn) {
      // Register activity and update session timeout on successful API calls
      store.commit(updateSessionTimeout)
    }

    return response
  },
  async (error) => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        // user is unauthorized, complete logout - this should clear all user data and tokens
        await logOut()
      }
    }
    return Promise.reject(error)
  }
)

export default instance
